import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";

import SiteLayout from "@/components/SiteLayout";
import SeoHead from "@/components/SeoHead";
import { LocalBusinessJsonLd } from "@/components/JsonLd";
import { DEFAULT_SEO } from "@/data/site";

import Hero from "@/components/lumiere/Hero";
import PartnerStrip from "@/components/lumiere/PartnerStrip";
import Services from "@/components/lumiere/Services";
import HowItWorks from "@/components/lumiere/HowItWorks";
import FurSpecialty from "@/components/lumiere/FurSpecialty";
import Testimonials from "@/components/lumiere/Testimonials";
import Contact from "@/components/lumiere/Contact";
import ServicePage from "@/pages/ServicePage";

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      let attempts = 0;

      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
          return;
        }
        if (attempts++ < 30) {
          requestAnimationFrame(tryScroll);
        }
      };

      const timer = setTimeout(tryScroll, 50);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

const Landing = () => (
  <SiteLayout testId="landing-page">
    <SeoHead
      title={DEFAULT_SEO.title}
      description={DEFAULT_SEO.description}
      keywords={DEFAULT_SEO.keywords}
      path="/"
    />
    <LocalBusinessJsonLd />
    <Hero />
    <PartnerStrip />
    <Services />
    <HowItWorks />
    <FurSpecialty />
    <Testimonials />
    <Contact />
  </SiteLayout>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/usluge/:slug" element={<ServicePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
